import { useForm } from "react-hook-form";
import { Container } from "../../components";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { getPrecio, getValidacion, sendRespuesta } from "./handler";
import InputRHF from "../../components/InputRHF";
import ContainerScreenGeneral from "../../components/ContainerScreenGeneral";
import { Button } from "react-bootstrap";
import { useGeneralAppStore } from "../../store/generalAppStore";
import ModalPdf from "../../components/Modals/ModalPdf";
import { useRifaStore } from "../../store/rifaStore";
import opcionesCantidad from '../../data/opcionesCantidad.json'
import opcionesIsArgentino from '../../data/opcionesIsArgentino.json'

import "./style.css"

// import imgLogo1 from "../../assets/PNG/fdlc_horizontal.png";
import imgLogo1 from "../../assets/PNG/logo20262.png";
import imgLogo2 from "../../assets/PNG/fdlc_vRecurso 3.png";
import Cargando from "../../components/Cargando";
import Loading from "../../components/Loading";
import { useNavigate } from "react-router-dom";
import useWindowSize from "../../hooks/useWindowSize";
import ModalCambioPrecio from "./components/ModalCambioPrecio";
import { toast } from "react-toastify";
import { toastOptions } from "../../config/toast";
import { Info } from "@mui/icons-material";
import ModalInfoDomicilio from "../../components/Modals/ModalInfoDomicilio";
import ModalDatosSolicitante from "../../components/Modals/ModalDatosSolicitante";
import ModalReenviarEmail from "../../components/Modals/ModalReenviarEmail";

export function Solicitud() {

    const { handlerModal, modals } = useGeneralAppStore();
    const { solicitud, precio, setPrecio } = useRifaStore();
    const size = useWindowSize();
    const { width, heigth } = size;
    const nav = useNavigate();
    const [errorForm, setErrorForm] = useState();
    const [loadingValidacion, setLoadingValidacion] = useState(false);
    const [linkPago, setLinkPago] = useState();

    const schema = yup.object({
        is_argentino: yup.string().transform((value, originalValue) => (originalValue === "" ? undefined : value))
            .required('Campo requerido'),
        dni: yup.string().required('DNI requerido')
            .when('is_argentino', {
                is: '1',
                then: () => yup
                    .string()
                    .matches(/^\d+$/, 'El DNI debe ser numérico')
                    .required("DNI requerido para argentinos")
                    .test(
                        'min-value',
                        'Min 7 dígitos',
                        (value) => Number(value) >= 1000000
                    ) // Validar el mínimo
                    .test(
                        'max-value',
                        'Máx 8 dígitos',
                        (value) => Number(value) <= 99999999
                    ), // Validar el máximo,
                otherwise: () => yup
                    .string()
                    .matches(/^\d+$/, 'El DNI debe ser numérico')
                    .required('DNI requerido para extranjeros')
            }),

        nombre_completo: yup.string().required('Nombre completo requerido'),
        email: yup.string().email('Email invalido').required('Email requerido'),
        email_confirmation: yup.string().required('Verificación requerida').oneOf([yup.ref('email'), null], 'Los emails deben ser iguales'),
        cantidad: yup.number().transform((value, originalValue) => (originalValue === "" ? undefined : value))
            .required('Cantidad requerida').min(1, 'El mínimo es 1').max(20, 'El máximo es de 20'),
        telefono: yup.string().transform((value, originalValue) => (originalValue === "" ? undefined : value))
            .required('Teléfono requerido').min(8, "El teléfono debe tener al menos 8 dígitos")
            .max(15, "El teléfono no debe exceder los 15 dígitos"),
        domicilio: yup.string().transform((value, originalValue) => (originalValue === "" ? undefined : value))
            .required('Domicilio requerido'),
        mayor: yup
            .boolean()
            .oneOf([true], 'Debes confirmar que eres mayor')
            .required('Este campo es requerido'),
        acepto: yup
            .boolean()
            .oneOf([true], 'Debes aceptar las bases y condiciones')
            .required('Este campo es requerido')

    })

    const [rta, setRta] = useState({
        data: null, error: null, loading: false, status: null
    })

    const [rtaPrecio, setRtaPrecio] = useState({
        data: null, error: null, loading: null
    })

    const [errorPrecio, setErrorPrecio] = useState();



    const {
        register,
        handleSubmit,
        watch,
        setValue,
        resetField,
        getValues,
        reset,
        clearErrors,
        formState: { errors },
    } = useForm({
        defaultValues: {
            // precio: precio,
            // is_argentino: true,
            // dni: "41738816",

            // nombre_completo: "Nahuel Chamorro",
            // domicilio: "Tort Oribe 96",
            // email: "nahu.chamo19@gmail.com",
            // email_confirmation: "nahu.chamo19@gmail.com",
            // cantidad: "1",
            // telefono: "2234558286"
        },
        resolver: yupResolver(schema)
    })

    const isArgentino = watch('is_argentino') || null;

    const getPrecioHandler = async (rta, setRta, clearErrors) => {
        await getPrecio(rta, setRta);
        clearErrors('precio');
    }

    const onSubmit = async (data) => {
        delete data.mayor;
        delete data.acepto;
        await getValidacion(data, setLoadingValidacion, setPrecio, precio);
        // handlerModal({ modal: true, modalName: "datos-solicitante" })

        // sendRespuesta(rta, setRta, data, setErrorPrecio, reset);
    }

    useEffect(() => {

        // if (rta?.data != null && rta?.status == 200) {
        //     nav('/pago')
        // }


        if (rta.error != null) {
            if (rta.status == 422) {
                if (!rta.error.precio) {
                    setErrorForm(rta.error)
                }
            } else {
                toast.error('Hubo un error en la consulta, vuelva a intentarlo nuevamente', toastOptions);
            }
        }

        // if (rta?.error?.precio) {
        //     console.log('entre')
        //     handlerModal({ modal: true, modalName: "cambio_precio" })
        // }

        // if (!rta.loading && !rta.data) {
        //     getPrecioHandler(rtaPrecio, setRtaPrecio);
        // }
    }, [rta])

    useEffect(() => {
        resetField('dni')
    }, [isArgentino])




    useEffect(() => {
        if (precio == 0 || precio == null) {
            getPrecioHandler(rtaPrecio, setRtaPrecio, clearErrors);
        }
        else {
            setValue('precio', precio)
        }


    }, [precio])




    return (

        <div className='position-relative container-home'>
            {
                (rta.loading || rtaPrecio.loading || loadingValidacion) &&
                <div className="position-absolute w-100 h-100 " style={{ background: "rgba(1,1,1,0.8)", zIndex: "99999" }}>
                    <Loading time={100} variant={2} />
                </div>
            }

            {/* {
                rtaPrecio.loading == false &&  */}
            <section className={`d-flex flex-column align-items-center w-100 pb-5 ${width < 430 && "pt-4"}`}>
                <img src={imgLogo1} width={"100%"} style={{ maxWidth: width > "1200" ? "600px" : "500px" }} className="mx-auto" />
                <form className="px-1 w-100 d-flex flex-column gap-2 " onSubmit={handleSubmit(onSubmit)} style={{ maxWidth: width <= 320 ? "270px" : width <= 430 ? "320px" : width > 1200 && width <= 1440 ? "800px" : width > 1440 ? "900px" : "700px" }}  >
                    {/* <p className="m-0 text-center w-100 mb-2" style={{ color: "#02E560", fontSize: width < 430 ? "14px" : "20px" }}>Comprando una rifa participas de todos los premios</p> */}
                    <p className="m-0 text-center w-100 mb-2" style={{ color: "#873DD1", fontSize: width < 430 ? "14px" : "20px" }}>Comprando una rifa participas de todos los premios</p>
                    <div className={` pb-2 px-1 d-flex justify-content-between align-items-center ${width < 430 ? " flex-column gap-2" : ""}`}>
                        <div className="d-flex flex-column gap-2">
                            {/* <p className="titulo-form text-center">Comprando una rifa participas de todos los premios</p> */}

                            <div>
                                <p className="titulo-form" style={{ color: "#873DD1" }}>¿Qué se rifa?</p>
                                {/* <p className="subtitulo-form">3 autos Toyota Yaris, 1 Toyota Hilux</p> */}
                                <p className="subtitulo-form" style={{ color: "#000" }}>3 autos Toyota Yaris</p>
                                <p className="subtitulo-form" style={{ color: "#000" }}>1 Toyota Hilux  4X4 DC DX 2.4 TDI 6 MT</p>
                                <p className="subtitulo-form" style={{ color: "#000" }}>4 Motos eléctricas</p>
                                <p className="subtitulo-form" style={{ color: "#000" }}>4 Monopatínes eléctricos</p>
                                {/* <p className="subtitulo-form d-fex flex-column"><span>3 autos Toyota Yaris 5p XS CVT automático</span>
                                    <span>1 Toyota Hilux  4X4 DC DX 2.4 TDI 6 MT</span></p> */}
                            </div>
                            <div>
                                <p className="titulo-form" style={{ color: "#873DD1" }}>¿Cuándo se rifa?</p>
                                <p className="subtitulo-form" style={{ color: "#000" }}>Cada noche de la Fiesta se rifará una unidad</p>
                            </div>
                            <div>
                                <p className="titulo-form" style={{ color: "#873DD1" }}>¿Cómo se rifa?/ Quién realiza la rifa?</p>
                                <p className="subtitulo-form" style={{ color: "#000" }}>La rifa se realiza a través del IJAN en vivo en el escenario.</p>
                            </div>
                        </div>
                        {/* <div>
                        <p className="titulo-form">FORMULARIO DE RIFAS</p>
                            <p className="subtitulo-form ">Complete los datos para realizar la compra</p>
                        </div>
                        
                        <div className={`d-flex ${width < 430 ? "gap-2 justify-content-center  w-100" : "flex-column"} align-items-center`}>
                            <p className="precio  ">Precio rifa</p>
                            <p className="num-precio ">$ {precio}</p>
                        </div> */}
                        <div className={`d-flex h-100  ${width < 430 ? "gap-2 justify-content-center  w-100" : "flex-column"} align-items-center`}>
                            <p className="precio  " style={{ color: "#873DD1" }}>Precio rifa</p>
                            <p className="num-precio " style={{ color: "#000" }}>$ {precio}</p>
                        </div>
                    </div>
                    <section>
                        <fieldset disabled={rta.loading} className={`mx-auto px-1`} >
                            <div className="row">
                                <InputRHF className={` ${width <= "430" ? "col-12" : "col-6"}`} label={'NOMBRE COMPLETO :'} campo={'nombre_completo'} type="text" register={register} errors={errors} placeholder={'NOMBRE . . .'} />
                                <InputRHF className={` ${width <= "430" ? "col-12" : "col-6"}`} label={'ES ARGENTINO :'} campo={'is_argentino'} type="select" opciones={opcionesIsArgentino} register={register} errors={errors} placeholder={'¿ES ARGENTINO ?'} />
                                <InputRHF className={` ${width <= "430" ? "col-12" : "col-12"} `} id={"largo"} label={'DOCUMENTO :'} argentino={watch('is_argentino')} campo={'dni'} type="number" register={register} errors={errors} placeholder={'DOCUMENTO . . .'} />
                                <div className={` ${width <= "430" ? "col-12" : "col-12"} position-relative`} >
                                    <div className="position-absolute text-white d-flex  gap-1" style={{ left: "10rem", top: "-3px", cursor: "pointer" }} onClick={() => { handlerModal({ modal: true, modalName: "info-domicilio" }) }}>
                                        {/* <Info color="primary" /> */}
                                    </div>
                                    {/* <InputRHF className={` ${width <= "430" ? "col-12" : "col-12"}`} label={'DOMICILIO COMPLETO :'} campo={'domicilio'} type="text" register={register} errors={errors} placeholder={'DOMICILIO . . .'} /> */}
                                    <InputRHF className={` ${width <= "430" ? "col-12" : "col-12"} `} id={"largo"} label={'DOMICILIO COMPLETO :'} campo={'domicilio'} type="text" register={register} errors={errors} placeholder={`${width <= 430 ? "-PROV.. -LOCALIDAD -CALLE -ALTURA" : "PROVINCIA - LOCALIDAD - CALLE - ALTURA"}  `} />
                                </div>
                                {/* <InputRHF className={` ${width <= "430" ? "col-12" : "col-6"}`} label={'DOCUMENTO :'} argentino={watch('is_argentino')} campo={'dni'} type="number" register={register} errors={errors} placeholder={'DOCUMENTO . . .'} /> */}

                                <InputRHF className={` ${width <= "430" ? "col-12" : "col-6"}`} label={'EMAIL :'} campo={'email'} type="email" register={register} errors={errors} placeholder={'EMAIL ...'} />
                                <InputRHF className={` ${width <= "430" ? "col-12" : "col-6"}`} label={'CONFIRMAR EMAIL :'} campo={'email_confirmation'} type="email" register={register} errors={errors} placeholder={'CONFIRMAR EMAIL'} />
                                <InputRHF className={` ${width <= "430" ? "col-12" : "col-6"}`} label={'TELEFONO :'} campo={'telefono'} type="number" register={register} errors={errors} placeholder={'TELEFONO . . .'} />
                                <InputRHF className={` ${width <= "430" ? "col-12" : "col-6"}`} label={'CANTIDAD :'} campo={'cantidad'} opciones={opcionesCantidad} type="select" register={register} errors={errors} placeholder={'CANTIDAD . . .'} />
                                <InputRHF className={` ${width <= "430" ? "col-12" : width <= "576" ? 'col- 12 text-center' : "col-12 "}  py-2`} label={'Declaro ser mayor de 18 años '} campo={'mayor'} opciones={opcionesCantidad} type="checkbox" register={register} errors={errors} placeholder={'Declaro ser mayor de edad'} />
                                {/* <InputRHF className={` ${width <= "430" ? "col-12" : width <= "576" ? 'col- 12 text-center' : "col-12 "}  py-2`} label={'Acepto las bases y condiciones'} link={"https://www.ijan-neuquen.com/reglamentos"} campo={'acepto'} opciones={opcionesCantidad} type="checkbox" register={register} errors={errors} placeholder={'Acepto las bases y condiciones'} /> */}
                                <InputRHF className={` ${width <= "430" ? "col-12" : width <= "576" ? 'col- 12 text-center' : "col-12 "}  py-2`} label={'Acepto las bases y condiciones'} link={"https://ijan-neuquen.com/reglamento.php?id=47"} campo={'acepto'} opciones={opcionesCantidad} type="checkbox" register={register} errors={errors} placeholder={'Acepto las bases y condiciones'} />
                            </div>
                            {(rta.error != null) ?
                                <>
                                    {
                                        errorForm
                                            ?
                                            <p className="text-danger text-center">{(errorForm)}</p>
                                            :
                                            errorPrecio
                                                ?
                                                <p className="text-danger text-center">{errorPrecio}</p>
                                                :
                                                <p className="text-danger text-center">{rta.error}</p>
                                    }
                                </>
                                :
                                <div style={{ height: width < 320 ? "72px" : width < 430 ? "48px" : "24px" }} />
                            }
                            <div className="d-flex px-3 w-100 justify-content-center pt-4">
                                <div className="">
                                    {/* <div className="py-1 px-4 boton-siguiente" style={{ fontSize: "1rem", boxShadow: "none", border: "none", cursor: "pointer" }} onClick={() => { handlerModal({ modal: true, modalName: "datos-solicitante" }) }} >SIGUIENTE</div> */}
                                    {/* <button className="py-1 px-4" style={{ fontSize: "1rem", boxShadow: "none", border: "none" }} onClick={() => { handlerModal({ modal: true, modalName: "datos-solicitante" }) }} >PAGAR</button> */}
                                    <button type="submit" className="py-1 px-4" style={{ fontSize: "1rem", boxShadow: "none", border: "none", color: "white" }} >SIGUIENTE</button>

                                </div>
                                {/* {rta.data &&
                                    <Button onClick={() => { handlerModal({ modal: "true", modalName: "descarga_pdf" }) }}  >Descargar PDF</Button>
                                } */}
                            </div>

                        </fieldset>
                    </section>


                </form>
                {modals.includes('reenviar-email') && <ModalReenviarEmail />}

                <div className="d-flex px-3 w-100 justify-content-center pt-4">
                    <div className="d-flex flex-column align-items-center gap-3">
                        <p className="text-center " style={{
                            color: "#000", width: width <= 576 ? "350px" : width <= 992 ? "550px" : "800px",
                            fontSize: width <= 576 ? "12px" : width <= 992 ? "16px" : "16px"
                        }}>Si no has recibido el email con la rifa haga click en "Reenviar Email"</p>
                        <button onClick={() => { handlerModal({ modal: true, modalName: "reenviar-email" }) }} className="py-1 px-4" style={{ fontSize: "1rem", boxShadow: "none", border: "none", color: "white" }} >REENVIAR EMAIL</button>
                    </div>
                </div>
            </section >
            {/* } */}


            {modals.includes('datos-solicitante') && <ModalDatosSolicitante getValues={getValues} handleSubmit={handleSubmit}
                rta={rta} setRta={setRta} data={getValues()} setErrorPrecio={setErrorPrecio} reset={reset} precio={precio}
                setLinkPago={setLinkPago} linkPago={linkPago}
            />}
            {/* <ContainerScreenGeneral size={'md'} bg={"#FBF3FF"}> */}
            {/* </ContainerScreenGeneral> */}
            {/* {console.log(modals)} */}
            {modals.includes('info-domicilio') && <ModalInfoDomicilio />}
            {modals.includes('descarga_pdf') && <ModalPdf />}
            {modals.includes('descarga_pdf') && <ModalCambioPrecio />}
            {/* </Container> */}
        </div>

    )
}